import axios from "axios";

export const MoviesActions = {
    GET_MOVIES_REQUEST: "GET_MOVIES_REQUEST",
    GET_MOVIES_SUCCESS: "GET_MOVIES_SUCCESS",
    GET_MOVIES_FAILURE: "GET_MOVIES_FAILURE",
};

export const getdataRequest = () => ({
    type: MoviesActions.GET_MOVIES_REQUEST
});

export const getdataSuccess = (data) => ({
    type: MoviesActions.GET_MOVIES_SUCCESS,
    payload: data
});

export const getdataFailure = () => ({
    type: MoviesActions.GET_MOVIES_FAILURE
});

export const fetchMovies = (payload) => (dispatch) => {
    const getdataActionreq = getdataRequest();
    dispatch(getdataActionreq);
    // Determine API URL based on hostname
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 
                   (window.location.hostname === 'iburrow.com' ? 'http://iburrow.com:2401' : 'http://localhost:2401');
    const apiUrl = `${baseUrl}/api/data`;
    return axios({
        url: apiUrl,
        method: "GET",
        params: {
            ...payload
        }
    })
        .then((res) => {
            const getdataActionres = getdataSuccess(res.data);
            dispatch(getdataActionres);
        })
        .catch((err) => {
            const getdataActionerr = getdataFailure();
            dispatch(getdataActionerr);
        });
};


